"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIDAS_COUNTRY = exports.COUNTRY = void 0;
var countries_1 = require("../config/countries");
var constants_1 = require("../utils/constants");
// 获取url参数
var searchParams = new URLSearchParams(location.search);
var context = {
    country: searchParams.get('country'),
    countryCode: Number(searchParams.get('countryCode')),
};
function getCountry(reg) {
    // 如果url有指定country参数，设置页面国家码
    if (context.country) {
        return {
            code: countries_1.findCountryCodeByName(context.country),
            name: context.country,
        };
    }
    // 如果url有指定countryCode参数，设置页面国家码
    if (context.countryCode) {
        return {
            code: context.countryCode,
            name: countries_1.findCountryNameByCode(context.countryCode),
        };
    }
    // 返回ua中指定的国家码
    var result = navigator.userAgent.match(reg);
    if (result && result.length > 2) {
        // 国家缩写需要根据国家码重置，ua的国家码固定为：th 国际版、vi 越南版、us 美国、iflix iflix
        var code = Number(result[1]);
        var name_1 = countries_1.findCountryNameByCode(code);
        return {
            code: code,
            name: name_1,
        };
    }
    // 兜底国家为美国
    return {
        code: constants_1.DEFAULT_COUNTRY.code,
        name: constants_1.DEFAULT_COUNTRY.name,
    };
}
// ua中是否存在MidasCountry
var midasCountryInUa = /MidasCountry/.test(navigator.userAgent);
var midasCountryField = getCountry(/MidasCountry\/([0-9]+)\(([a-z-]+)\)/);
// 基于IP的国家码
exports.COUNTRY = getCountry(/Country\/([0-9]+)\(([a-z-]+)\)/);
// 基于midas的国家码
exports.MIDAS_COUNTRY = midasCountryInUa ? midasCountryField : exports.COUNTRY;
